module.exports = __webpack_public_path__ + "img/blog6.08933bcd.jpg";